import React from "react";

import { UseFormReturn } from "react-hook-form";

import {
    Box,
    Button,
    Typography
} from "@mui/material";

import {
    t,
    Trans
} from "@lingui/macro";

import {
    ZPlayLoader,
    NavigationBack
} from "commons";

import { ManageCountryState } from "./models";
import { DefaultTypedResponse } from "models/response";
import { Country } from "models";

import { ContentProducerService } from "services/content-producer-service";
import AddIcon from "@mui/icons-material/Add";
import { withSnackbar, WithSnackbarProps } from "notistack";
import { CountryTable, CreateAndEditCountryModal } from "components/backoffice/country/index";

class ManageCountry extends React.Component<UseFormReturn & WithSnackbarProps, ManageCountryState>{

    constructor(props: any) {
        super(props);

        this.state = {
            searchFilter: null,
            pagination: { pageSize: 20, pageIndex: 0 },
            countryCount: 0,
            countryList: [],
            data: null,
            isLoading: true,
            openEditCountryModal: false,
            openCreateCountryModal: false,
            editCountry: null
        };
    }

    public componentDidMount() {
        this.getPaginatedCountryWithStateParameters();
    };

    private paginationUpdated = (pagination: any) => {

        ////****
        // VERY VERY IMPORTANTE! Mongoose Paginate prende di default come prima pagina la pagina 1, mentre la tabella la pagina 0. Serve questo piccolo workaround
        ////****

        this.setState(() => ({
            isLoading: true,
            pagination: pagination
        }), () => ContentProducerService.getCountryListPaginated([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getCountryCallback, this.getCountryErrorCallback));

    }

    private getPaginatedCountryWithStateParameters = () => {

        this.setState(() => ({
            isLoading: true,
        }));

        ContentProducerService.getCountryListPaginated([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getCountryCallback, this.getCountryErrorCallback);
    }

    private deleteCountry = (id: string): void => {

        this.setState(() => ({
            isLoading: true,
        }));

        if ((this.state.countryList.length - 1) % this.state.pagination.pageSize === 0 && this.state.pagination.pageIndex !== 0) {
            this.setState((prevState) => ({
                pagination: {
                    ...prevState.pagination,
                    pageIndex: this.state.pagination.pageIndex - 1
                }
            }));
        }

        ContentProducerService.deleteCountry(id, this.getPaginatedCountryWithStateParameters, this.deleteCountryErrorCallback);
    }


    private getCountryCallback = (data: DefaultTypedResponse<Country>): void => {

        this.setState(() => ({
            countryCount: data.size,
            countryList: data.list,
            isLoading: false,
        }));
    };

    private editCountryCallback = (): void => {
        this.setState(() => ({ openEditCountryModal: false }));
        this.getPaginatedCountryWithStateParameters();
    };

    private createCountryCallback = (): void => {
        this.setState(() => ({ openCreateCountryModal: false }));
        this.getPaginatedCountryWithStateParameters();
    };

    private deleteCountryErrorCallback = (err: any): void => {
        this.setState(() => ({
            isLoading: false
        }));

        this.props.enqueueSnackbar(t({
            id: "mc-error-delete-country",
            message: "Si è verificato un errore. Il paese non è stato eliminato"
        }), {
            variant: "error",
        });
    }

    private getCountryErrorCallback = (err: any): void => {
        this.setState(() => ({
            isLoading: false
        }));


        this.props.enqueueSnackbar(t({
            id: "mc-error-get-country",
            message: "Si è verificato un errore."
        }), {
            variant: "error",
        });
    };

    private editCountryErrorCallback = (err: any): void => {
        this.setState(() => ({
            openEditCountryModal: false
        }));

        this.props.enqueueSnackbar(t({
            id: "mc-error-edit-country",
            message: "Si è verificato un errore. Il paese non è stato modificato"
        }), {
            variant: "error",
        });
    };

    private createCountryErrorCallback = (err: any): void => {
        this.setState(() => ({
            openCreateCountryModal: false
        }));

        this.props.enqueueSnackbar(t({
            id: "mc-error-create-country",
            message: "Si è verificato un errore. Il paese non è stato creato"
        }), {
            variant: "error",
        });
    };


    private openEditCountryModal = (Country: Country): void => {
        this.setState(() => ({
            openEditCountryModal: true,
            editCountry: Country
        })
        )
    }

    private closeModal = (): void => {
        this.setState(() => ({
            openEditCountryModal: false,
            editCountry: null,
            openCreateCountryModal: false
        }));
    };

    private openCreateCountryModal = (): void => {
        this.setState(() => ({
            openCreateCountryModal: true,
        })
        )
    }

    render() {
        return (
            <Box sx={{ textAlign: "center", p: 5 }}>
                <NavigationBack/>
                <Typography variant="h2" color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                    <Trans id="mc-text-title">Paesi</Trans>
                </Typography>
                <Box sx={{ textAlign: "right", pr: 2 }}>
                    <Button
                        endIcon={<AddIcon />}
                        onClick={this.openCreateCountryModal}
                        variant={"contained"}
                    >
                        <Trans id="mc-button-add">Aggiungi</Trans>
                    </Button>
                </Box>
                {<Box sx={{ p: 2, mt: 2 }}>
                    <CountryTable
                        pagination={this.state.pagination}
                        countries={this.state.countryList}
                        totalCountryCount={this.state.countryCount}
                        deleteCountry={this.deleteCountry}
                        openEditCountryTable={this.openEditCountryModal}
                        updatePaginationCallBackFn={this.paginationUpdated}
                    />
                </Box>}
                {this.state.openEditCountryModal && <CreateAndEditCountryModal
                    closeModal={this.closeModal}
                    editCountryCallback={this.editCountryCallback}
                    editCountryErrorCallback={this.editCountryErrorCallback}
                    country={this.state.editCountry}
                />}
                {this.state.openCreateCountryModal && <CreateAndEditCountryModal
                    closeModal={this.closeModal}
                    createCountryCallback={this.createCountryCallback}
                    createCountryErrorCallback={this.createCountryErrorCallback}
                />}
                {this.state.isLoading && <ZPlayLoader />}
            </Box>);
    }
}

export default withSnackbar(ManageCountry);